<template>
  <div>
  <keep-alive :include="keepAliveList">
    <router-view></router-view>
  </keep-alive>
    <van-tabbar class="menuTabbar" route style="height: 15.73vw;box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.35);" :border="false" inactive-color="#9B9999" active-color="#515151">
      <van-tabbar-item :to="MyMenu + '/shop'">
        <span style="font-size: 2.93vw;font-weight: bold">首页</span>
        <template slot-scope="props" slot="icon">
          <img style="width: 5.87vw; height: 5.87vw" :class="props.active ? 'shakeMenu' : ''" :src="props.active ? icon.newHome1 : icon.newHome2" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item :to="MyMenu + '/shopSearch'" @click="set_keepAliveList([])">
        <span style="font-size: 2.93vw;font-weight: bold">分类</span>
        <template slot-scope="props" slot="icon">
          <img style="width: 5.87vw; height: 5.87vw" :class="props.active ? 'shakeMenu' : ''" :src="props.active ? icon.fenLei1 : icon.fenLei2" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item :to="MyMenu + '/buyCart'">
        <span style="font-size: 2.93vw;font-weight: bold">购物车</span>
        <template slot-scope="props" slot="icon">
          <img style="width: 5.87vw; height: 5.87vw" :class="props.active ? 'shakeMenu' : ''" :src="props.active ? icon.newBuyCart1 : icon.newBuyCart2" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item :to="MyMenu + '/mine'">
        <span style="font-size: 2.93vw;font-weight: bold">我的</span>
        <template slot-scope="props" slot="icon">
          <img style="width: 5.87vw; height: 5.87vw" :class="props.active ? 'shakeMenu' : ''" :src="props.active ? icon.newmyMine1 : icon.newmyMine2" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import newHome1 from '../assets/img/icon/tabbar_icon_home_selected.png'
import newHome2 from '../assets/img/icon/tabbar_icon_home_default.png'
import fenLei1 from '../assets/img/icon/tabbar_icon_classify_selected.png'
import fenLei2 from '../assets/img/icon/tabbar_icon_classify_default.png'
import newBuyCart1 from '../assets/img/icon/tabbar_icon_shopping_selected.png'
import newBuyCart2 from '../assets/img/icon/tabbar_icon_shopping_default.png'
import newmyMine1 from '../assets/img/icon/tabbar_icon_personal_selected.png'
import newmyMine2 from '../assets/img/icon/tabbar_icon_personal_default.png'
// import message1 from '../assets/img/tabbar_icon_notice_default@2x.png'
// import message2 from '../assets/img/tabbar_icon_notice_selected@2x.png'

import {mapGetters, mapActions} from 'vuex'
export default {
  name: 'MyMenu',
  data () {
    return {
      MyMenu: '/myMenu',
      icon: {
        newHome1,
        newHome2,
        fenLei1,
        fenLei2,
        newBuyCart1,
        newBuyCart2,
        newmyMine1,
        newmyMine2,
        // message1,
        // message2
      },
      noticeObj: {},
      infoCheck: false,
      showDaiLi: false,
      showHeZuo: false,
      serviceAgreement: false,
      timeOut: null
    }
  },
  created () {
    // this.noReadNoticeNum()
    // this.timeOut = setInterval(() => {
    //   this.noReadNoticeNum()
    // }, 1000)
    // this.findNew()
    // this.isRealName()
    // this.isSign()
  },
  destroyed () {
    // clearInterval(this.timeOut)
  },
  computed: {
    ...mapGetters({
      keepAliveList: 'get_keepAliveList'
    })
  },
  watch: {
    // $route () {
    //   this.noReadNoticeNum()
    // }
  },
  methods: {
    ...mapActions([
      'set_keepAliveList'
    ]),
    noReadNoticeNum () {
      // this.$toast.loading()
      this.$request.notice.noReadNoticeNum()
        .then((response) => {
          this.noticeObj = response.data
          // this.$toast.clear()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    showDifferentDaiLi () {
      this.serviceAgreement = false
      this.showDaiLi = true
    },
    showDifferentDaiLiClose () {
      this.serviceAgreement = true
      this.showDaiLi = false
    },
    showDifferentHeZuo () {
      this.serviceAgreement = false
      this.showHeZuo = true
    },
    showDifferentHeZuoClose () {
      this.serviceAgreement = true
      this.showHeZuo = false
    },
    showWhrite () {
      this.$request.exam.sign()
        .then((response) => {
          this.$toast(response.msg)
          if (response.code === '200') {
            this.serviceAgreement = false
            // this.$router.push('/myMenu')
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    findNew () {
      return new Promise(resolve => {
        this.$request.wallet.isAgent()
          .then((response) => {
            this.$toast.clear()
            if (response.data.agentFlag === 1) {
              this.isRealName().then(() => {
                this.$toast.clear()
              })
            } else {
              resolve()
            }
          })
          .catch((error) => {
            console.log(error)
          })
      })
    },
    isRealName () {
      return new Promise(resolve => {
        this.$request.wallet.isRealName()
          .then((response) => {
            this.$toast.clear()
            if (!response.data.realNameFlag) {
              this.$dialog.confirm({
                message: '此操作需进行实名认证，是否前往认证'
              })
                .then(() => {
                  this.$router.replace('/authenticationReal')
                })
                .catch(() => {
                  // on cancel
                  this.$router.replace('/myMenu/shop')
                })
            } else {
              resolve()
              this.isBindCard().then(() => {
                this.$toast.clear()
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      })
    },
    isBindCard () {
      return new Promise(resolve => {
        this.$request.wallet.isBindCard()
          .then((response) => {
            this.$toast.clear()
            if (response.data.isBindCard === 0) {
              this.$dialog.confirm({
                message: '此操作需进行绑定银行卡，是否前往绑定'
              })
                .then(() => {
                  this.$router.replace('/walletBalance')
                })
                .catch(() => {
                  this.$router.replace('/myMenu/shop')
                })
            } else {
              resolve()
              this.isSign().then(() => {
                this.$toast.clear()
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      })
    },
    isSign () {
      return new Promise(resolve => {
        this.$request.wallet.isSign()
          .then((response) => {
            this.$toast.clear()
            if (!response.data.signFlag) {
              this.serviceAgreement = true
            } else {
              resolve()
            }
          })
          .catch((error) => {
            console.log(error)
          })
      })
    }
  }
}
</script>

<style>
  .menuArc {
    position: absolute;
    opacity: 0;
    bottom: 0;
    left: -7.2vw;
    width: 20vw;
    height: auto !important;
    z-index: -1;
    transform: translateY(-5.33vw);
    transition: transform .3s;
  }
  .menuArc.menuArcActive {
    opacity: 1;
    transform: translateY(-6.13vw);
  }
  /*.menuTabbar .van-tabbar-item {*/
  /*  justify-content: inherit;*/
  /*  padding-top: 1.33vw;*/
  /*}*/
  .menuTabbar .van-tabbar-item__icon {
    margin-bottom: 1.33vw;
  }
  .shakeMenu {
    /*animation-name: shake;*/
    /*animation-duration: 1.5s;*/
  }
  @keyframes shake {
    /*0%   {transform: rotate(0deg)}*/
    25%  {transform: rotate(-15deg)}
    /*50%  {transform: rotate(0deg)}*/
    75%  {transform: rotate(15deg)}
    100% {transform: rotate(0deg)}
  }
</style>
